import { Capacitor } from "@capacitor/core";

/** Disable long-press text selection on native shells; inputs opt back in via CSS. */
export function initNativeAppUi(): void {
  if (!Capacitor.isNativePlatform()) return;
  document.documentElement.classList.add("native-app");
}
